export { generateBtcAddress } from "./generateBtcAddress";
